import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.scr.nagro.app/auth'
})

export default api;